import { render, staticRenderFns } from "./buyerBindingSetting.vue?vue&type=template&id=034a2cac&"
import script from "./buyerBindingSetting.vue?vue&type=script&lang=js&"
export * from "./buyerBindingSetting.vue?vue&type=script&lang=js&"
import style0 from "./buyerBindingSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports